import type { DateRange } from "../../../../common/src";
import { navigate } from "../../hooks/useRoute";
import { formatDays } from "../../utils/format";
import { Button } from "../shared/Button";

interface QuickReserveProps {
  boatId: number;
  dates: DateRange;
  partySize: number | undefined;
}

/** From search results, go straight to signing the Boat Loan Agreement for these dates. */
export const QuickReserve = ({
  boatId,
  dates,
  partySize,
}: QuickReserveProps) => (
  <Button
    onClick={() =>
      navigate({ page: "reserve", boatId, trip: { ...dates, partySize } })
    }
  >
    Reserve {formatDays(dates)}
  </Button>
);
